import axios from 'axios';

export const arsInfoManagementApi = axios.create({
  baseURL: process.env.REACT_APP_ARS_INFO_MANAGEMENT_API,
});
